module.exports = () ->
  return {
    restrict: 'A'
    link: (scope) ->
      prev = scope.workflowStepIterations[scope.step.id][scope.key - 1]
      if prev
        if (prev['from_date'] != scope.iteration['from_date'] or
            prev['to_date'] != scope.iteration['to_date']) and
            scope.iteration['from_date'] and
            scope.iteration['to_date']
          scope.date_changed = true

        if prev['translated_query'] != scope.iteration['translated_query'] and scope.iteration['translated_query']
          scope.query_changed = true
  }
